import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { ArrowDown } from "lucide-react";

const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_villa-sucuraj/artifacts/t7c7eljn_Villa_Loop_Hvar.mp4";
const FALLBACK_IMG =
  "https://customer-assets.emergentagent.com/job_villa-sucuraj/artifacts/e8vx9ifm_IMG_9462.jpeg";

export const Hero = () => {
  const { t } = useLang();
  const [line1, line2] = (t.hero.title || "").split("\n");

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden bg-[#1a1a1a]"
    >
      {/* Background video */}
      <video
        data-testid="hero-video"
        className="absolute inset-0 w-full h-full object-cover"
        src={VIDEO_URL}
        poster={FALLBACK_IMG}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />

      {/* Cinematic dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/20 to-black/60" />

      {/* Content */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-end pb-24 md:pb-32">
        <span
          data-testid="hero-eyebrow"
          className="text-[#F8F5F0]/80 text-xs uppercase tracking-[0.32em] font-medium mb-8"
        >
          {t.hero.eyebrow}
        </span>
        <h1
          data-testid="hero-title"
          className="font-serif font-light text-[#F8F5F0] text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.02] tracking-tight max-w-4xl drop-shadow-sm"
        >
          {line1}
          {line2 && (
            <>
              <br />
              <span className="italic font-light">{line2}</span>
            </>
          )}
        </h1>
        <p
          data-testid="hero-subtitle"
          className="mt-8 max-w-xl text-[#F8F5F0]/90 text-base md:text-lg leading-relaxed font-light"
        >
          {t.hero.subtitle}
        </p>

        <div className="mt-12 flex flex-wrap items-center gap-6">
          <a
            href="#booking"
            data-testid="hero-cta-booking"
            className="group inline-flex items-center gap-3 bg-[#C05C3D] hover:bg-[#a64c30] text-[#F8F5F0] px-8 py-4 text-xs uppercase tracking-[0.22em] font-semibold transition-colors"
          >
            {t.hero.cta}
            <span className="inline-block w-6 h-px bg-current group-hover:w-10 transition-all duration-300" />
          </a>
          <a
            href="#about"
            data-testid="hero-scroll"
            className="flex items-center gap-3 text-[#F8F5F0]/80 hover:text-[#F8F5F0] text-xs uppercase tracking-[0.22em] font-medium"
          >
            <span className="inline-block w-10 h-px bg-current" />
            {t.hero.scroll}
            <ArrowDown className="h-3.5 w-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
};
